import { IAppState } from '../../redux';
import { EPublishTermsStatus } from '../../redux/reducers';
import { getUserTariff } from '../../utils';

export function selectIsServicePositionAvailable(state: IAppState): boolean {
  const {
    user,
    publishTerms: { status, selectedServiceId },
  } = state;

  const { isBase, isPro } = getUserTariff(user);
  const isTariffAvailable = isBase || isPro;
  const isPublishTermsLoaded = status === EPublishTermsStatus.success;
  const isServiceAvailable = selectedServiceId !== 'servicePackage';

  return isTariffAvailable && isPublishTermsLoaded && isServiceAvailable;
}
